import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initErrorLogging } from "./utils/errorLogger";

// Initialize error logging before anything else
initErrorLogging();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
